// import formatTime from '@/utils/common.js';
export const tableConfig = {
    searchList: {
        // defaultValue: {
        //     billDate: [formatTime.initStartDate(30), formatTime.initEndDate()]
        // },
        searchTxt: [
            {
                type: 'input',
                value: 'barcodeNo',
                span: 6,
                name: '条码字符串',
                clearable: true
            },
            {
                type: 'input',
                value: 'sourceBillNo',
                span: 6,
                name: '来源单号',
                clearable: true
            },
            {
                type: 'input',
                value: 'taskNo',
                span: 6,
                name: '任务号',
                clearable: true
            },
            // {
            //     type: 'datePicker',
            //     value: 'creationDate',
            //     clearable: true,
            //     span: 6,
            //     name: '创建时间'
            // },
            {
                type: 'datePicker',
                value: 'billDate',
                clearable: true,
                span: 6,
                name: '单据日期'
            },
            {
                type: 'datePicker',
                value: 'opDate',
                clearable: true,
                span: 6,
                name: '扫码日期'
            }
        ]
    },
    table: {
        sequence: true,
        // leftOperation: true,
        showOtpColumnConfig: true,
        rowKey: 'swapId',
        height: 'calc( 100vh - 220px )', // 样式被穿透了
        columns: [
            {
                fixed: 'left',
                label: '条码号',
                align: 'center',
                prop: 'barcodeNo',
                width: 200
            },
            {
                fixed: 'left',
                label: '扫码日期',
                align: 'center',
                prop: 'opDate',
                width: 180
            },
            {
                label: '产品编码',
                align: 'center',
                prop: 'itemCode',
                width: 200
            },
            {
                label: '产品描述',
                align: 'center',
                prop: 'itemName',
                width: 250
            },
            {
                label: '订单号',
                align: 'center',
                prop: 'sourceBillNo',
                width: 150
            },
            {
                label: '任务号',
                align: 'center',
                prop: 'taskNo',
                width: 300
            },
            {
                label: '来源系统',
                align: 'center',
                prop: 'sourceSystem',
                width: 200
            },
            {
                label: '扫码来源',
                align: 'center',
                prop: 'scanSystem',
                width: 150
            },
            {
                label: '业务类型编码',
                align: 'center',
                prop: 'billTypeClass',
                width: 150
            },
            {
                label: '业务类型名称',
                align: 'center',
                prop: 'billTypeName',
                width: 150
            },
            {
                label: '单据日期',
                align: 'center',
                prop: 'billDate',
                width: 180
            },
            {
                label: '箱码',
                align: 'center',
                prop: 'cartonBarcodeNo',
                width: 180
            },
            {
                label: '托盘码',
                align: 'center',
                prop: 'palletBarcodeNo',
                width: 200
            },
            {
                label: '小包装内商品数量',
                align: 'center',
                prop: 'boxCount',
                width: 200
            },
            {
                label: '产品单位',
                align: 'center',
                prop: 'uomCode',
                width: 200
            },
            {
                label: '发车单号',
                align: 'center',
                prop: 'dispatchNo',
                width: 200
            },
            {
                label: '当前仓库',
                align: 'center',
                prop: 'whName',
                width: 200
            },
            {
                label: '出入库类型',
                align: 'center',
                prop: 'inoutType',
                width: 200
            },
            {
                label: '发货单位编码',
                align: 'center',
                prop: 'shipOrgCode',
                width: 200
            }, {
                label: '发货单位类型',
                align: 'center',
                prop: 'shipOrgType',
                width: 200
            },
            {
                label: '发货单位名称',
                align: 'center',
                prop: 'shipOrgName',
                width: 200
            },
            {
                label: '发货财务仓编码',
                align: 'center',
                prop: 'shipOrgWhCode',
                width: 200
            },
            {
                label: '发货财务仓名称',
                align: 'center',
                prop: 'shipOrgWhName',
                width: 200
            },
            {
                label: '收货单位编码',
                align: 'center',
                prop: 'recOrgCode',
                width: 200
            },
            {
                label: '收货单位类型',
                align: 'center',
                prop: 'recOrgType',
                width: 200
            },
            {
                label: '收货单位名称',
                align: 'center',
                prop: 'recOrgName',
                width: 200
            },
            {
                label: '收货财务仓编码',
                align: 'center',
                prop: 'recOrgWhCode',
                width: 200
            },
            {
                label: '收货财务仓名称',
                align: 'center',
                prop: 'recOrgWhName',
                width: 200
            },
            {
                label: '配送方式编码',
                align: 'center',
                prop: 'deliveryType',
                width: 200
            },
            {
                label: '配送方式',
                align: 'center',
                prop: 'deliveryTypeName',
                width: 200
            },
            {
                label: '物流公司编码',
                align: 'center',
                prop: 'logisticsCompanyCode',
                width: 200
            },
            {
                label: '快递单号',
                align: 'center',
                prop: 'expressCode',
                width: 200
            },
            // {
            //     label: '司机',
            //     align: 'center',
            //     prop: 'driver',
            //     width: 200
            // },
            {
                label: '承运商名称',
                align: 'center',
                prop: 'carrierName',
                width: 200
            },
            {
                label: '承运商编码',
                align: 'center',
                prop: 'carrierCode',
                width: 200
            },
            {
                label: '服务平台',
                align: 'center',
                prop: 'siteName',
                width: 200
            },
            {
                label: '业务类型',
                align: 'center',
                prop: 'businessMode',
                width: 200
            },
            {
                label: '发货单位详细地址',
                align: 'center',
                prop: 'senderDetailAddrDees',
                width: 200
            },
            {
                label: '收货单位详细地址',
                align: 'center',
                prop: 'receiverDetailAddrDees',
                width: 200
            }
        ]
    },
    page: {
        layout: 'total, sizes, prev, pager, next, jumper',
        pageSize: 10,
        pageNo: 1,
        pageSizes: [10, 20, 30, 50, 100]
    },
    showPage: true
};
